import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { trackNearbyModule } from './util';

import { connect } from 'react-redux';
import { safeGet } from '../../util/object';

class Track extends PureComponent {
  componentDidMount() {
    const { locationList, source, trackingProperties, newBooking, login } = this.props;
    const accountId = safeGet(login)('login.account_id');
    const userProfileId = safeGet(newBooking)('booking.userProfileId');
    const props = { ...trackingProperties, accountId, userProfileId };
    trackNearbyModule(locationList, props, source);
  }

  render() {
    return null;
  }
}

Track.propTypes = {
  locationList: PropTypes.array.isRequired,
  trackingProperties: PropTypes.object,
  newBooking: PropTypes.object,
  login: PropTypes.object,
  source: PropTypes.string,
};

const mapStateToProps = state => ({
  trackingProperties: state.sessionTrackingProperties,
  newBooking: state.newBooking,
  login: state.login,
});

export default connect(
  mapStateToProps,
  null
)(Track);
